<div class="agpr-mediaMonitoringApiKeyCard">
    <div class="agpr-mediaMonitoringApiKeyCard-badge">
        {{ (apiKey.disabled ? 'AMT.mediaMonitoringApi.suspended' : 'AMT.mediaMonitoringApi.active') | localize }}
    </div>

    <div class="agpr-mediaMonitoringApiKeyCard-field">
        <div class="agpr-mediaMonitoringApiKeyCard-label">
            {{ 'AMT.apiKeys.management.apiKey' | localize }}
        </div>
        <div class="agpr-mediaMonitoringApiKeyCard-content">
            {{ apiKey.keyValue }}
        </div>
    </div>

    <div class="agpr-mediaMonitoringApiKeyCard-field">
        <div class="agpr-mediaMonitoringApiKeyCard-label">
            {{ 'AMT.mediaMonitoringApi.createdBy' | localize }}
        </div>
        <div class="agpr-mediaMonitoringApiKeyCard-content">
            {{ apiKey.createdBy || 'N/A' }}
        </div>
    </div>

    <div class="agpr-mediaMonitoringApiKeyCard-field">
        <div class="agpr-mediaMonitoringApiKeyCard-label">
            {{ 'AMT.mediaMonitoringApi.createdDate' | localize }}
        </div>
        <div class="agpr-mediaMonitoringApiKeyCard-content">
            {{ apiKey.createdDate | date: 'MMMM d, yyyy h:mm a' }}
        </div>
    </div>
</div>
